export default {
    props: {
        to: {
            type: [Function, String, Number, Object],
        },

        replace: {
            type: Boolean,
        },
    },

    computed: {
        action() {
            return () => {
                if (typeof this.to === 'function') {
                    return this.to()
                }

                return this.$goto(this.to, {
                    replace: this.replace,
                    defaultTo: this.defaultTo,
                })
            }
        },
    },

    methods: {
        defaultTo() {
            return null
        },
    },
}
